import { useMemo } from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { isIndianUser } from "@/utils/getCountryCode";
import { filterNavItemsForIndia } from "@/utils/region";
import { withRegionPath } from "@/utils/session";
import { getActiveModuleTabId, MODULE_NAV_TABS } from "./moduleNavConfig";
import styles from "./ModuleNav.module.css";

export default function ModuleNav({ variant = "header", className = "" }) {
  const router = useRouter();
  const isIndia = isIndianUser();

  const tabs = useMemo(
    () =>
      filterNavItemsForIndia(MODULE_NAV_TABS, isIndia).map((tab) => ({
        ...tab,
        href: withRegionPath(tab.href),
      })),
    [isIndia]
  );

  const activeTab = useMemo(
    () => getActiveModuleTabId(router.pathname),
    [router.pathname]
  );

  const variantClass =
    variant === "navbar"
      ? styles.navbarVariant
      : variant === "navbarMobile"
        ? styles.navbarMobileVariant
        : styles.headerVariant;

  return (
    <nav
      className={`${styles.nav} ${variantClass} ${className}`.trim()}
      aria-label="Product categories"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;

        return (
          <a
            key={tab.id}
            href={tab.href}
            className={`${styles.tab} ${isActive ? styles.tabActive : ""}`}
            aria-current={isActive ? "page" : undefined}
          >
            <span className={styles.tabIcon}>
              <Image
                src={isActive ? tab.redicon : tab.icon}
                alt=""
                width={20}
                height={20}
                className={styles.tabIconImg}
                quality={70}
                loading="lazy"
              />
            </span>
            {tab.label}
          </a>
        );
      })}
    </nav>
  );
}
